import type { FilterRuleListResponse } from "@cdt/shared";
import { useQuery } from "@tanstack/react-query";

import { fetchFilterRules } from "@/lib/filtersApi";

export const FILTER_RULES_QUERY_KEY = ["filterRules"] as const;

export function useFilterRulesQuery() {
  return useQuery<FilterRuleListResponse>({
    queryKey: FILTER_RULES_QUERY_KEY,
    queryFn: fetchFilterRules,
    staleTime: 10_000,
  });
}
